import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'


import './index.scss'

const KEY_REGEX = /:([a-zA-Z_]+)/g

const _renderLevel = (level, levelIndex, levels, keys) => {
  // show arrow only if isn't the last level
  const isLast = levelIndex === levels.length - 1
  const Arrow = !isLast ? (
    <span className="material-icons">keyboard_arrow_right</span>
  ) : null

  let levelName = level.name
  if ( levelName.search(KEY_REGEX) >= 0 )
    levelName = level.name.replace(KEY_REGEX, (match, key) => keys.displayValues[key] || key)

  let levelPath = level.path
  if ( level.path.search(KEY_REGEX) >= 0 )
    levelPath = levelPath.replace(KEY_REGEX, (match, key) => keys.pathValues[key] || key)

  const to = isLast ? '#' : levelPath
  return (
    <div key={levelIndex} className="d-inline-flex align-items-center">
      <li>
        <Link to={to}>{levelName}</Link>
      </li>
      { Arrow }
    </div>
  )
}

export default function Breadcrumb(props, context) {
  return (
    <nav id="Breadcrumb">
      <ul className="d-inline-flex">
        { props.levels.map((level, levelIndex, levels) => _renderLevel(level, levelIndex, levels, props.keys)) }
      </ul>
    </nav>
  )
}

Breadcrumb.defaultProps = {
  keys: {}
}

Breadcrumb.propTypes = {
  levels: PropTypes.array.isRequired,
  keys: PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/Breadcrumb/index.js